/// <reference path="../../js/_ResizeObserver.ts" />
import Component from '../../js/_Component';
import ResizeClasses from '../../js/util/_ResizeClasses';

export default class BoatBanner extends Component {
	/**
	 * The background, used to determine sizing of the component content.
	 */
	private backgroundElement: HTMLElement;

	/**
	 * The element containing inner contents of the banner.
	 */
	private contentElement: HTMLElement;

	/**
	 * The video, which is automatically sized to cover the background.
	 */
	private videoElement: HTMLVideoElement;

	/**
	 * The play/pause button.
	 */
	private controlElement: HTMLButtonElement;

	constructor(element: HTMLElement) {
		super(element);

		this.backgroundElement = this.element.querySelector('.c-boat-banner--background');
		this.contentElement = this.element.querySelector('.c-boat-banner--content');
		this.videoElement = this.element.querySelector('.c-boat-banner--video');
		this.controlElement = this.element.querySelector('.c-boat-banner--video-control');

		// Is this a video slide?
		if (this.videoElement) {
			this.controlElement.addEventListener('click', () => this.toggleVideo());
		}

		// Set mobile mode.
		new ResizeClasses(this.element, {
			'm-mobile': {
				max: 768,
			},
		});

		// Below mobile size, content should change to a compact mode.
		this.element.addEventListener('resizeclassesapplied', () => {
			const compact = this.element.classList.contains('m-mobile');
			const decoratedBannerBox = this.contentElement.querySelector('.c-decorated-banner-box');
			decoratedBannerBox.dispatchEvent(new CustomEvent('updatecompactmode', {detail: compact}));
		});
	}

	toggleVideo() {
		this.element.classList.contains('m-paused')
			? this.playVideo()
			: this.pauseVideo();
	}

	playVideo() {
		this.element.classList.remove('m-paused');
		this.videoElement.play();
	}

	pauseVideo() {
		this.element.classList.add('m-paused');
		this.videoElement.pause();
	}
}

Component.register(BoatBanner, 'BoatBanner');
